import * as t from 'ts-schema';
export default function valueUnion(obj) {
  return t.union(...Object.values(obj).map(val => t.literal(val)));
}